import React, { useEffect, useState } from "react";
import axios from "axios";
import { IconBox, IconEntree, IconLock } from "./icons";
import "./styles.css";

//const API_URL = "https://localhost:8443/api/assets/etat-stock";
const API_URL = "https://app.bicadev.com/api/assets/etat-stock";

/** Les compteurs restent lisibles avant l'arrivée de la réponse. */
const compteur = (bloc) => bloc?.count ?? "—";
const metrage = (bloc) =>
  typeof bloc?.metrage === "number" ? bloc.metrage.toFixed(0) : "—";

export default function HomePage() {
  const [etat, setEtat] = useState(null);
  const [erreur, setErreur] = useState(false);

  useEffect(() => {
    axios
      .get(API_URL)
      .then((res) => setEtat(res.data))
      .catch(() => setErreur(true));
  }, []);

  return (
    <div className="home-page">
      <div className="home-hero">
        <div className="home-brand">
          <img
            src={`${process.env.PUBLIC_URL}/logo-sip-blanc.png`}
            alt=""
          />
          Groupe SIP
        </div>

        <h1>SIP STOCK</h1>
        <p>Système de gestion des mouvements de stock</p>
      </div>

      {erreur && (
        <div className="alert-error" style={{ marginTop: 0, marginBottom: 14 }}>
          État du stock indisponible
        </div>
      )}

      <div className="stock-dashboard">
        <div className="stat-card green">
          <div className="stat-card-icon">
            <IconBox />
          </div>
          <div className="stat-card-body">
            <div className="stat-card-label">Stock Réel</div>
            <div className="stat-card-value">{compteur(etat?.stockReel)}</div>
            <div className="stat-card-meta">{metrage(etat?.stockReel)} m</div>
          </div>
        </div>

        <div className="stat-card orange">
          <div className="stat-card-icon">
            <IconLock />
          </div>
          <div className="stat-card-body">
            <div className="stat-card-label">Stock Réservé</div>
            <div className="stat-card-value">{compteur(etat?.stockReserve)}</div>
            <div className="stat-card-meta">{metrage(etat?.stockReserve)} m</div>
          </div>
        </div>

        <div className="stat-card blue">
          <div className="stat-card-icon">
            <IconEntree />
          </div>
          <div className="stat-card-body">
            <div className="stat-card-label">En cours d'entrée</div>
            <div className="stat-card-value">{compteur(etat?.stockEnCours)}</div>
            <div className="stat-card-meta">{metrage(etat?.stockEnCours)} m</div>
          </div>
        </div>
      </div>

      <div className="home-footer">SIP ERP — Module Inventaire</div>
    </div>
  );
}
